export default __webpack_public_path__ + "img/08be7ab50d0f638964b8e7eae5192a03.jpg";